<template>

    <v-section col="col-md-10">
        <h4 v-if="headline">Helping hundreds of the most tech-savvy marketers onboard their customers and reduce churn with personalized automations</h4>
        <div class="logos">
            <img v-for="i in count" :key="i" :src="url(i)" />
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .logos {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        img {
            border-top: 1px solid $color-rule-light;
            border-left: 1px solid $color-rule-light;
            height: auto;
            width: 100%;
        }
        @media (min-width: map-get($grid-breakpoints, 'sm')) {
            img {
                &:nth-child(5n+1) {
                    border-left: none;
                }
                &:nth-child(-n+5) {
                    border-top: none;
                }
            }
        }
        @media (max-width: map-get($grid-breakpoints, 'sm')) {
            grid-template-columns: repeat(2, 1fr);
            img {
                &:nth-child(odd) {
                    border-left: none;
                }
                &:nth-child(-n+2) {
                    border-top: none;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        headline: {
            type: Boolean,
            default: true,
        },
        count: {
            type: Number,
            default: 10,
        },
    },

    methods: {

        url(i) {
            const num = i < 10 ? '0' + i : i;
            return `/img/clients/clients_${num}.jpg`;
        },

    },

}

</script>